























import { Component, Vue } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAdjust } from '@fortawesome/free-solid-svg-icons/faAdjust';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import Button from '@/components/buttons/HeaderButton.vue';
import { Routes } from '../router';

library.add(faAdjust, faGithub);

@Component({
	components: {
		Button,
	},
})
export default class Header extends Vue {
	handleDarkMode() {
		const html = document.querySelector('html');
		if (html && html.classList.contains('dark')) {
			html.classList.remove('dark');
		} else if (html) {
			html.classList.add('dark');
		}
	}

	handleHome() {
		this.$router.push(Routes.Home);
	}
}
